module.exports = __webpack_public_path__ + "9fa92b9c95837135884fb0632b2f723c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/pic11.png
// module id = 1855
// module chunks = 0